import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n';

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  // Get current language name
  const currentLangData = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === currentLanguage,
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          id="tour-language-switcher"
          variant="ghost"
          size="icon"
          className="h-9 w-9 hover:bg-gray-100"
        >
          <Globe className="h-5 w-5" />
          <span className="sr-only">{t('common.change.language')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {SUPPORTED_LANGUAGES.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={
              currentLanguage === lang.code ? 'bg-gray-100 font-medium' : ''
            }
          >
            <span className="mr-2">{currentLanguage === lang.code && '✓'}</span>
            <span className="mr-2">{lang.native}</span>
            <span className="text-sm text-gray-500">({lang.name})</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
